(() => {
  function init(root = document) {
    root.querySelectorAll('.vj-category-nav > details').forEach(details => {
      if (details.dataset.vjReady) return;
      details.dataset.vjReady = 'true';
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector('.vj-menu-panel');
      const sync = () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) {
          const panelTop = details.parentElement.getBoundingClientRect().bottom;
          const height = Math.max(180, window.innerHeight - panelTop - 16);
          panel.style.maxHeight = `${height}px`;
          panel.style.setProperty('--vj-list-height', `${height - 54}px`);
          panel.style.marginLeft = '';
          const overflow = details.parentElement.getBoundingClientRect().left + 600 - window.innerWidth + 16;
          panel.style.marginLeft = overflow > 0 ? `-${overflow}px` : '';
        }
      };
      details.addEventListener('toggle', sync);
      let leaveTimer;
      const open = () => {
        document.querySelectorAll('.site-navigation > li > details[open]').forEach(other => { if (other !== details) other.open = false; });
        details.open = true;
      };
      details.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(leaveTimer);
        open();
      });
      details.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        leaveTimer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 160);
      });
      document.addEventListener('pointerover', event => {
        const item = event.target.closest('.site-navigation > .site-nav__item');
        if (item && !item.contains(details) && !details.contains(document.activeElement)) details.open = false;
      });
      let pointerType;
      summary.addEventListener('pointerdown', event => { pointerType = event.pointerType; });
      summary.addEventListener('click', event => {
        if (event.detail > 0 && pointerType === 'mouse') { event.preventDefault(); open(); }
      });
      summary.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          details.open = true;
          panel.querySelector('a')?.focus();
        }
      });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        const sub = event.target.closest('.vj-menu__sub[open]');
        if (sub) {
          sub.open = false;
          sub.querySelector('summary').focus();
        } else {
          details.open = false;
          summary.focus();
        }
      });
      details.addEventListener('focusout', () => {
        setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 0);
      });
      window.addEventListener('resize', sync, {passive:true});
      document.addEventListener('click', () => queueMicrotask(sync));
      panel.querySelectorAll('.vj-menu__sub').forEach(sub => {
        sub.addEventListener('toggle', () => {
          if (sub.open) panel.querySelectorAll('.vj-menu__sub[open]').forEach(other => { if (other !== sub) other.open = false; });
        });
        let subPointerType;
        const subSummary = sub.querySelector('summary');
        subSummary.addEventListener('pointerdown', event => { subPointerType = event.pointerType; });
        subSummary.addEventListener('click', event => {
          if (event.detail > 0 && subPointerType === 'mouse') { event.preventDefault(); sub.open = true; }
        });
        subSummary.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') sub.open = true;
        });
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
